export enum FeatureToggleKey {
  LogsDetailed = "fe_logs_detailed",
  showGlobalSearch = "show_global_search",
  ExportConsumption = "l_fe_new_consumption_report",
  useNewCustomerService = "ftv2_wk_all_usenewcustomerservice",
  RecommendLeakAfterMeterAlert = "ftv2_fe_all_nem-recommend-leak-after-meter-alert"
}

export interface GetFeatureToggleResponse {
  featureName: string;
  isEnabled: boolean;
}

